module.exports = EDShared;